import React, { useEffect, useState } from "react";
import "./PayrollAdmin.scss"; 
import PayrollAdminTable from "../../components/PayrollAdminTable/PayrollAdminTable";
import PayrollAdminTableFilterHeader from "../../components/PayrollAdminTableFilterHeader/PayrollAdminTableFilterHeader";
import PayrollAdminTableHeader from "../../components/PayrollAdminTableHeader/PayrollAdminTableHeader";
import PayrollAdminCreation from "../../components/PayrollAdminCreation/PayrollAdminCreation";
import { getPortalUsers } from "../../util/API/admin"; 
import { useSelector, useDispatch } from "react-redux";
import { setPortalUsers } from "../../store/redux/portalUsers";
import { getSystemStatus } from "../../util/API/admin";
import { Box, CircularProgress } from "@mui/material";

function PayrollAdmin() {
  const [open, setOpen] = useState(false);
  const [payrollFilterList, setPayrollFilterList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [updateUser, setUpdateUser] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isViewAssociates, setIsViewAssociates] = useState(false);
  const [viewAssociatesAdmin, setViewAssociatesAdmin] = useState(null); 
  const dispatch = useDispatch();
  const requiredConstants = useSelector((state) => state.constants);

  let configVariables = useSelector((state) => state.config.baseConfig);

  console.log("this is the payrol admin id for the current environment",configVariables);

  const systemStatus = async () => {
    const response = await getSystemStatus();
    console.log(response);
  };

  // ====================== CLEAN COMPANY NAME ======================
  const cleanCompanyName = (raw) => {
    if (!raw) return "-";

    let name = String(raw)
      .replace(/&amp;amp;/g, "&")
      .replace(/&amp;#039;/g, "'")
      .replace(/&amp;#39;/g, "'")
      .replace(/&amp;/g, "&")
      .replace(/&#039;/g, "'")
      .replace(/&#39;/g, "'")
      .replace(/&quot;/g, '"')
      .replace(/&#34;/g, '"')
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&nbsp;/g, " ")
      .trim();

    // Optional but highly recommended: extract real company name when it's prefixed like "code:&quot;name&quot;"
    if (name.includes(":")) {
      const parts = name.split(":");
      let extracted = parts[parts.length - 1].trim();
      extracted = extracted.replace(/^["']|["']$/g, ""); // remove wrapping quotes
      if (extracted) name = extracted;
    }

    return name || "-";
  };
  // ===============================================================

  const systemRoles = async () => {
    const allRoles = requiredConstants.systemRoles || [];

    // Filter ONLY the External Payroll Admin role (roleid "configVariables.payRollAdminId")
    const payrollRoleWrapper = allRoles.find(roleWrapper => 
      roleWrapper.securityrole.roleid === configVariables.payRollAdminId
    );

    let transformedRoles = [];
    if (payrollRoleWrapper) {
      const role = payrollRoleWrapper.securityrole;
      transformedRoles = [{
        key: role.roleid,
        value: role.roleid,
        label: role.name,
      }];
      console.log("✅ Filtered Payroll Role for Creation Modal (roleid:payrolladminid):", transformedRoles);
    } else {
      console.warn("⚠️ Role ID (External Payroll Admin) not found in systemRoles!");
    }

    setRoles([{
      key: configVariables.payRollAdminId,
      value: configVariables.payRollAdminId,
      label: "External Payroll Admin",
    }]);
  };

  useEffect(() => {
    systemStatus();
    systemRoles();
  }, [requiredConstants]);

  // const payrollUsers = async () => {
  //   setLoading(true);
  //   setPayrollFilterList([]); // ← ADD THIS: clear stale list immediately
  //   setUsers([]);             // ← ADD THIS: clear stale users too

  //   const response = await getPortalUsers();
  //   console.log("payrollUsers----------", response);
  //   const userList = response?.payload || [];
  //   console.log('userList------------------------->', userList)
  //   const usersArray = Array.isArray(userList) ? userList : [userList].filter(Boolean).filter((user) => user.Securityuserrole.roleid === configVariables.payRollAdminId);
  //   setUsers(usersArray);

  //   dispatch(setPortalUsers(usersArray));
  //   setLoading(false);
  // };
  const payrollUsers = async () => {
  setLoading(true);
  setPayrollFilterList([]);
  setUsers([]);

  const response = await getPortalUsers();
  console.log("payrollUsers----------", response);
  const userList = response?.payload || [];
  console.log('userList------------------------->', userList);

  // Always convert to array first, THEN filter by payrollAdminId
  const usersArray = Array.isArray(userList) ? userList : [userList].filter(Boolean);
  
  const filteredUsers = usersArray.filter((user) => {
    const userRoles = Array.isArray(user.Securityuserrole)
      ? user.Securityuserrole
      : user.Securityuserrole ? [user.Securityuserrole] : [];
    return userRoles.some((role) => role.roleid === configVariables.payRollAdminId);
  });

  console.log(`Filtered ${filteredUsers.length} users with payrollAdminId: ${configVariables.payRollAdminId}`);

  setUsers(filteredUsers);
  dispatch(setPortalUsers(filteredUsers));
  setLoading(false);
};
  useEffect(() => {
    payrollUsers();
  }, [updateUser]);

  
  // Filter users to show ONLY those with roleid " (External Payroll Admin)
  useEffect(() => {
    if (users.length > 0) {
      // 1. Filter by role
      let payrollUsersOnly = users.filter((user) => {
        const userRoles = Array.isArray(user.Securityuserrole)
          ? user.Securityuserrole
          : user.Securityuserrole ? [user.Securityuserrole] : [];

        return userRoles.some((role) => role.roleid === configVariables.payRollAdminId);
      });

      // 2. Clean company names (otherNames) and first/last names for everyone
      payrollUsersOnly = payrollUsersOnly.map((user) => ({
        ...user,
        Vuser: {
          ...user.Vuser,
          firstName: cleanCompanyName(user.Vuser?.firstName),
          lastName: cleanCompanyName(user.Vuser?.lastName),
          otherNames: cleanCompanyName(user.Vuser?.otherNames),
        },
      }));

      console.log(`Filtered to ${payrollUsersOnly.length} External Payroll Admins`);

      // 3. Sort once
      const sortedUsers = [...payrollUsersOnly].sort((a, b) => b.Vuser.id - a.Vuser.id);

      // 4. Apply search (on cleaned data)
      if (searchText.trim() === "") {
        setPayrollFilterList(sortedUsers);
      } else {
        const filtered = payrollUsersOnly.filter(
          (user) =>
            user.Vuser.firstName.toLowerCase().includes(searchText.toLowerCase()) ||
            user.Vuser.lastName.toLowerCase().includes(searchText.toLowerCase()) ||
            user.Vuser.emailAccount.toLowerCase().includes(searchText.toLowerCase()) ||
            user.Vuser.telephoneno.includes(searchText) ||
            (user.Vuser.otherNames &&
              user.Vuser.otherNames.toLowerCase().includes(searchText.toLowerCase()))
        );

        setPayrollFilterList(filtered.sort((a, b) => b.Vuser.id - a.Vuser.id));
      }
    }
  }, [users, searchText, configVariables.payRollAdminId]);

  return (
    <>
      <PayrollAdminCreation
        open={open}
        handleClose={handleClose}
        roles={roles}  
        updateUser={updateUser}
        setUpdateUser={setUpdateUser}
        payrollUsers={payrollFilterList}
      />

      <Box className="page-container admin-container">
        <Box
          className="header-container"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box style={{ display: "flex" }}>
            <Box className="admin-header">Payroll Admin</Box>
            <Box className="admin-subtitle" style={{ marginLeft: 10 }}>
              External Payroll User Management
            </Box>
          </Box>

          <PayrollAdminTableFilterHeader
            handleOpen={handleOpen}
            setSearchText={setSearchText}
            searchText={searchText}
          />
        </Box>

        <Box className="admin-table-container">
          {loading ? (
            <CircularProgress />
          ) : (
            <>
              <PayrollAdminTableHeader payrollFilterList={payrollFilterList}  hideTotal={isViewAssociates} />
              <PayrollAdminTable
                payrollFilterList={payrollFilterList}
                updateUser={updateUser}
                setUpdateUser={setUpdateUser}
                payrollUsers={payrollUsers}
                systemRoles={requiredConstants.systemRoles}
                payRollAdminId={configVariables.payRollAdminId}
                setIsViewAssociates={setIsViewAssociates}
                 isViewAssociates={isViewAssociates}
                   viewAssociatesAdmin={viewAssociatesAdmin}         // ← add
  setViewAssociatesAdmin={setViewAssociatesAdmin}   // ← add
              />
            </>
          )}
        </Box>
      </Box>
    </>
  );
}

export default PayrollAdmin;